import type { MetricWithAttribution } from 'web-vitals/attribution'

export type WebVitalsHandler = (metric: MetricWithAttribution) => void

// web-vitals@4 (flag REACT_APP_WEB_VITALS_ENABLED, DESIGN-CLARITY §7.2 Q5):
// the three Core Web Vitals from the attribution build, so the handler also
// learns WHICH element was the LCP / shifted / was interacted with. Called
// without a handler (= the flag off) this is the same no-op as before: the
// library is never imported and no chunk is downloaded. FID/FCP/TTFB are
// dropped on purpose (FID is gone in v4; FCP/TTFB are not what the
// measurement gate looks at).
const reportWebVitals = async (onPerfEntry?: WebVitalsHandler): Promise<void> => {
  if (typeof onPerfEntry === 'function') {
    await import('web-vitals/attribution').then(({ onCLS, onINP, onLCP }) => {
      onCLS(onPerfEntry)
      onINP(onPerfEntry)
      onLCP(onPerfEntry)
    })
  }
}

export default reportWebVitals
